import React from 'react';
import { Route, Switch } from 'react-router-dom';
// import { CategoryPage } from '../../pages/category/CategoryPage';
import NotFoundPage from '../../pages/not-found-page/NotFoundPage';
import AccountingRoutes from './accounting-routes/AccountingRoutes';
// import { StatisticsProvider } from '../../contexts/statistics-context/StatisticsContext';
import ReportsRoutes from './reports-routes/ReportsRoutes';
// const HomePage = lazy(() => import('../../pages/home-page/HomePage'));

const PartnerRoleRoutes = () => {
  return (
    <Switch>
      {/* accounts routes */}
      {AccountingRoutes()}
      {/* ./accounts routes */}

      {/* Reports routes */}
      {ReportsRoutes()}
      {/* Reports routes */}

      {/* not found page */}
      <Route path="*" component={NotFoundPage} />
    </Switch>
  );
};

export default PartnerRoleRoutes;
